import { AdminAppState } from '../../state';
import { UpdatePlaceInput } from '../../mutations';
import { getCreatePlaceInput } from './get-create-place-input';

export const getUpdatePlaceInput = (placeKey: string) => (
  state: AdminAppState,
): UpdatePlaceInput => getCreatePlaceInput(placeKey)(state);
